const { __ } = wp.i18n;
const {
  registerBlockType,
  createBlock
} = wp.blocks
const {
  BlockControls,
  AlignmentToolbar,
  InspectorControls,
  RichText,
} = wp.blockEditor
const {
  TextControl,
  Button,
  Card,
  CardBody,
  PanelRow,
} = wp.components

registerBlockType("parone/video-playlist", {
  title: __("ParOne Video Playlist", "parone"),
  icon: "analytics",
  category: "parone",
  attributes: {
    feedId: {
      type: "string",
      default: ""
    },
  },
  edit: props => {

    // Lift info from props and populate various constants.
    const {
      attributes: {
        feedId
      },
      className,
      setAttributes
    } = props;

    const change = key => value => setAttributes({[key]:value})
    return [
      <InspectorControls>
        <Card>
          <CardBody>
              <TextControl
                label= 'Feed ID'
                value= {feedId}
                onChange= {change('feedId')}
              />
          </CardBody>
        </Card>
      </InspectorControls>
      ,
      <parone-video-playlist feed={feedId}/>
    ];
  },
  save: props => {
    const {
      attributes: {
        feedId
      },
      className
    } = props;


    return ( <parone-video-playlist feed={feedId}/>);
  }
});
